import { render } from "./BasePrice.vue?vue&type=template&id=7f3ccd80"
import script from "./BasePrice.vue?vue&type=script&lang=js"
export * from "./BasePrice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/petertoh/Sites/martin-keehn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__